import React, { useEffect, useState } from 'react';
import { Button, Col, Divider, Image, Modal, Row, Upload } from 'antd';
import UserProfileForm from './ProfileForm';
import MyButton from './Button';
import CustomerForm from './CustomerForm';
import Typography from './Typography';
import { COLORS } from '../constants/Colors';
import useIsDesktop from '../utils/hooks/useIsDesktop';
import TrackingModal from './TrackingModal';
import _ from 'lodash';
import GetProfile from './VariableStore';
import { instance } from './AxiosClient';
import { FormattedMessage, useIntl } from 'react-intl';
import { errorNotification, successNotification } from './Notification';
import ShipmentPreviewModal from './ShipmentPreviewModal';
import OrderModal from './OrderModal';
import { DownOutlined, EditOutlined, UpOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive';
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import ReactBnbGallery from "react-bnb-gallery";
import moment from 'moment';
import { useIsTablet } from '../utils/hooks/useMobile';

// import { useState } from "react";

const ShipmentDetailModal = (props) => {
  const {
    isOpen,
    onCancle,
    info,
    onClickPrint,
    onCancleShipment,
    isPreview,
    setEvent,
    setIsOpen,
    fromTracking,
    shipmentData,
    setDetailModal,
    setFocusShipmentDetail,
  } = props;
  const isDesktop = useIsDesktop();

  const isTablet = useIsTablet();

  const [isOpenTrackingModal, setIsOpenTrackingModal] = useState(false);
  const [focusedTracking, setFocusedTracking] = useState();
  const [trackingDetail, setTrackingDetail] = useState([]);
  const [isOpenPreviewModal, setIsOpenPreviewModal] = useState(false);
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);
  const [isOpenOrderModal, setIsOpenOrderModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [collaps, setCollaps] = useState(true);
  const [fileList, setFileList] = useState([])
  const [visibleImgGallery, setVisibleImgGallery] = useState(false)
  const [modalViewGallery, setModalViewGallery] = useState([])
  const [startIndexGallery, setStartIndexGallery] = useState(0);

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');

  const intl = useIntl();
  const customerId = GetProfile('customerId');
  const comCode = GetProfile('customerCode');


  const name = _.get(info, 'contact.customerContactName');
  const phone = _.get(info, 'contact.customerContactPhone');
  const address = _.get(info, 'destination.address');
  const remark = _.get(info, 'remark');
  const customerShippingPrice = _.get(info, 'customerShippingPrice');
  const totalParcel = parseInt(_.get(info, 'totalParcel')) || 0;
  const orderId = _.get(info, 'orderId');
  const orderNo = _.get(info, 'orderNo');
  const orderType = _.get(info, 'orderType')
  const referenceNo = _.get(info, 'referenceNo');
  const statusCode = _.get(info, 'statusCode');
  const parcels = _.get(info, 'pacelDetails');
  const confirmFilter = _.filter(parcels, (item) => { return item.statusText === 'Confirmed' })
  const isMoblie = useMediaQuery({ query: '(max-width: 300px)' });
  const createdDate = _.get(info, 'createdAtTxt');
  const planShippingDate = _.get(info, 'planShippingDate') ? moment(_.get(info, 'planShippingDate'), 'DD/MM/YYYY H:mm:ss').format('DD/MM/YYYY H:mm') : ''
  const actualShippingDate = _.get(info, 'actualShippingTxt') ? moment(_.get(info, 'actualShippingTxt'), 'DD/MM/YYYY H:mm:ss').format('DD/MM/YYYY H:mm') : ''
  const etaDate = _.get(info, 'planShippingTime') ? moment(_.get(info, 'planShippingTime'),'HH:mm').add(+30, 'minutes').format('HH:mm') : ''


  // const [fileList, setFileList] = useState(
  //   [
  //     {url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'},
  //     {url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'},
  //   ]);

  useEffect(() => {
    if (isOpen === true) {
      getData();
      // const editData = _.get(
      //   _.filter(shipmentData, (e) => {
      //     return _.get(e, 'contact.customerContactId') === _.get(info, 'contact.customerContactId');
      //   }),
      //   '[0]'
      // );
      // //console.log('EditData', shipmentData);
      // setDetailModal(editData);
    }
  }, [isOpen, isEdit]);

  useEffect(() => {
    if (isCancel === true && isOpenConfirmModal === false) {
      getInfo();
    }
  }, [isOpenConfirmModal]);



  const getData = async () => {
    const body = {
      orderNo: _.get(info, 'orderNo'),
      isMerchant: true,
    };

    try {
      const response = await instance.post(`v5/order/manager/company/${comCode}/web/public/order/tracking`, body);
      setTrackingDetail(response.data.data);
      setFileList(response.data.data.taskPhoto ? response.data.data.taskPhoto.map((url, index) => {
        return {
          index: index,
          url: url,
        }
      }) : [])
    } catch (error) { }
  };

  const getInfo = async () => {
    const search = {
      'contact.customerContactName': '',
      'contact.customerContactPhone': '',
      'customer.comtomerName': '',
      'destination.address': '',
      orderNo: orderNo,
      sizesizeName: '',
      sourceaddress: '',
      weightTxt: '',
    };

    const body2 = {
      search: search,
      'customer.customerId': customerId,
      limit: 1,
    };

    const response = await instance.post(`/v5/order/manager/company/${comCode}/web/deliveryorder/report/loopmerchant`, body2);

    if (fromTracking === true) {
      setDetailModal(_.get(response.data.data.list, '[0]'));
    } else {
      setFocusShipmentDetail(_.get(response.data.data.list, '[0]'));
    }
  };

  const handleClickPrint = () => {
    // setIsEdit(false);
    setIsOpenPreviewModal(true);
    onClickPrint();
    // onCancle();

  };

  const handleClickCancelTracking = () => {
    setIsOpenTrackingModal(false);
  };

  const handleClosePreviewModal = () => {
    setIsOpenPreviewModal(false);
  };

  const handleClickCancelShipment = async () => {
    const id = orderId;

    const body = {
      statusDetail: {
        sequence: 2,
        statusCode: 'canceled',
        statusColor: '#898989',
        statusId: process.env.REACT_APP_CANCELSTATUS_ID,
        statusName: 'Canceled',
        statusText: { EN: 'Canceled', TH: 'ยกเลิก' },
      },
    };

    try {
      await instance.put(`/v5/order/manager/company/${comCode}/web/deliveryorder/loopmerchant/${id}`, body);
      fromTracking === true && setEvent((current) => !current);
      setIsCancel(true);
      setIsOpenConfirmModal(false);
      successNotification(intl.formatMessage({ id: 'saveSuccessNotification', defaultMessage: 'Success' }));
    } catch (error) {
      errorNotification(intl.formatMessage({ id: 'saveErrorNotification', defaultMessage: 'Failed' }));
    }
  };

  const handleClickCreateOrder = () => {
    setIsEdit(true);
    setIsOpenOrderModal(true);
  };

  const handleCloseOrderModal = () => {
    setIsOpenOrderModal(false);
  };

  const saveEditOrder = (value) => {
    setIsEdit(false);
    fromTracking === true && setEvent((current) => !current);
    handleCloseOrderModal();
    setTimeout(() => {
      getInfo();
    }, 1000);
    // //console.log('EditData', value);
    // if (fromTracking === true) {
    //   setDetailModal(_.get(value, '[0]'));
    // } else {
    //   setFocusShipmentDetail(_.get(value, '[0]'));
    // }
    // onCancle()
  };

  const onCollapsPhoto = () => {
    setCollaps(value => !value)
  }

  const handlePreview = (file) => {

    setPreviewImage(file.url);
    setPreviewOpen(true);

  }

  // const handlePreview = (file) => { // lib rapidword
  //   console.log('file', file, fileList)
  //   const mapPhoto = fileList && _.size(fileList) !== 0 ? fileList.map((item, index) => { // ReactBnbGallery
  //     return {
  //       photo: _.get(item, 'url'),
  //       number: index,
  //       caption: _.get(item, 'name'),
  //       thumbnail: _.get(item, 'url'),
  //       uid: _.get(item, 'uid')
  //     }
  //   }
  //   ) : []
  //   // const mapPhoto = fileList && _.size(fileList) !== 0 ? fileList.map((item, index) => { // ImageGallery
  //   //   return {
  //   //     original: _.get(item, 'url'),
  //   //     thumbnail: _.get(item, 'url'),
  //   //     index: index,
  //   //   }
  //   // }
  //   // ) : []
  //   const found = mapPhoto.findIndex((element) => element.uid === file.uid);
  //   setModalViewGallery(mapPhoto)
  //   setVisibleImgGallery(true)
  //   setStartIndexGallery(found)
  // }

  return (
    <Modal
      // style={{ paddingBottom: !isDesktop ? '50px' : null }}
      bodyStyle={{ paddingBottom: !isDesktop ? '35px' : null, height: !isDesktop ? 'calc(100vh - 200px)' : null }}
      title={
        <Typography color={COLORS.Primary} isBold size='16px' className={isDesktop ? 'pb-3' : 'text-center pb-2'}>
          <FormattedMessage id='modalShipmentDetails' defaultMessage='Shipment Details' />
        </Typography>
      }
      maskClosable={false}
      open={isOpen}
      onOk={() => { }}
      onCancel={onCancle}
      width={680}
      centered={isDesktop ? true : false}
      footer={
        isPreview ? (
          statusCode === 'open' ? (
            isDesktop ? (
              <>
                <MyButton
                  onClick={onCancle}
                  style={{
                    width: isDesktop ? '22%' : '100%',
                  }}
                >
                  <FormattedMessage id='btnClose' defaultMessage='Close' />
                </MyButton>

                <MyButton
                  onClick={() => {
                    setIsOpenConfirmModal(true);
                  }}
                  style={{
                    width: isDesktop ? '22%' : '30%',
                  }}
                >
                  <FormattedMessage id='btnCancelShipment' defaultMessage='Cancel Shipment' />
                </MyButton>
                <MyButton
                  isPrimary
                  onClick={handleClickPrint}
                  style={{
                    width: isDesktop ? '22%' : '30%',
                  }}
                >
                  <FormattedMessage id='btnPrint' defaultMessage='Print' />
                </MyButton>
              </>
            ) : (
              <div style={{ backgroundColor: '#fff' }}>
                <MyButton
                  isPrimary
                  onClick={handleClickPrint}
                  style={{
                    width: isDesktop ? '25%' : '100%',
                    marginBottom: '10px',
                  }}
                >
                  <FormattedMessage id='btnPrintTransportWaybill' defaultMessage='Print Transport Waybill' />
                </MyButton>

                <MyButton
                  onClick={() => {
                    // onCancleShipment();
                    setIsOpenConfirmModal(true);
                  }}
                  style={{
                    width: isDesktop ? '25%' : '100%',
                    marginLeft: '0px',
                    marginBottom: '10px',
                  }}
                >
                  <FormattedMessage id='btnCancelShipment' defaultMessage='Cancel Shipment' />
                </MyButton>

                <MyButton
                  onClick={onCancle}
                  style={{
                    width: isDesktop ? '22%' : '100%',
                    marginLeft: '0px',
                  }}
                >
                  <FormattedMessage id='btnClose' defaultMessage='Close' />
                </MyButton>
              </div>
            )
          ) : (
            [
              <MyButton
                isPrimary
                onClick={onCancle}
                style={{
                  width: isDesktop ? '25%' : '100%',
                }}
              >
                <FormattedMessage id='btnClose' defaultMessage='Close' />
              </MyButton>,
            ]
          )
        ) : (
          [
            <MyButton
              isPrimary
              onClick={onCancle}
              style={{
                width: isDesktop ? '25%' : '100%',
              }}
            >
              <FormattedMessage id='btnClose' defaultMessage='Close' />
            </MyButton>,
          ]
        )
      }
    >
      <Divider className='m-0' />
      <Row>
        {isDesktop ? (
          <Col span={18}>
            <div className='s d-flex pt-4 pb-3'>
              <Typography isBold size={isDesktop ? '20px' : '16px'}>
                {name}
              </Typography>
              <Typography size={isDesktop ? '20px' : '16px'} color={COLORS.DarkGray} className='pl-2'>
                {phone}
              </Typography>
            </div>
          </Col>
        ) : isTablet ? (
          <Col span={18}>
            <div className='s d-flex pt-4 pb-3'>
              <Typography isBold size={isDesktop ? '20px' : '16px'}>
                {name}
              </Typography>
              <Typography size={isDesktop ? '20px' : '16px'} color={COLORS.DarkGray} className='pl-2'>
                {phone}
              </Typography>
            </div>
          </Col>
        ) : isMoblie ? (
          <Col span={isDesktop ? 20 : 20}>
            <div className='d-flex pt-4 pb-3'>
              <Row>
                <Col span={16}>
                  <Typography isBold size={isDesktop ? '20px' : '16px'}>
                    {name}
                  </Typography>
                </Col>
                <Col span={16}>
                  <Typography size={isDesktop ? '20px' : '16px'} color={COLORS.DarkGray} className='pt-2'>
                    {phone}
                  </Typography>
                </Col>
              </Row>
            </div>
          </Col>
        ) : (
          <Col span={isDesktop ? 20 : 20}>
            <div className='d-flex pt-4 pb-3'>
              <Row>
                <Col span={16}>
                  <Typography isBold size={isDesktop ? '20px' : '16px'}>
                    {name}
                  </Typography>
                </Col>
                <Col span={16}>
                  <Typography size={isDesktop ? '20px' : '16px'} color={COLORS.DarkGray} className='pt-2'>
                    {phone}
                  </Typography>
                </Col>
              </Row>
            </div>
          </Col>
          // <Col span={isDesktop ? 20 : 20}>
          //   <div className='s d-flex pt-4 pb-3'>
          //     <Typography isBold size={isDesktop ? '20px' : '16px'}>
          //       {name}
          //     </Typography>

          //     <Typography size={isDesktop ? '20px' : '16px'} color={COLORS.DarkGray} className='pl-2'>
          //       {phone}
          //     </Typography>
          //   </div>
          // </Col>
        )}

        {statusCode === 'open' ? (
          <Col span={isDesktop ? 5 : isMoblie ? 4 : 4}>
            <div className={`d-flex ${isDesktop ? 'pt-4 pb-1 pl-5' : 'pt-4 pb-1 pl-1'}`}>
              <MyButton
                onClick={handleClickCreateOrder}
                disabled={_.size(confirmFilter) > 0 ? true : false}
                style={{
                  width: isDesktop ? '100%' : isMoblie ? '100%' : '80%',
                  paddingLeft: isMoblie ? '10px' : '13px'
                }}
              >
                <EditOutlined /> {isDesktop ? <FormattedMessage id='btnEdit' defaultMessage='Edit' /> : ''}
              </MyButton>
            </div>
          </Col>
        ) : null}
      </Row>

      <div
        style={{
          backgroundColor: _.get(info, 'statusColor'),
          width: 'fit-content',
          padding: '0 36px',
          borderRadius: '16px',
          color: '#FFF',
          fontSize: isMoblie ? '14px' : ''
          // marginBottom: "16px",
        }}
      >
        {_.get(info, 'statusText')}
      </div>
      <Divider className='m-0 my-3' />
      <Typography isBold color={COLORS.Primary} className='pb-2'>
        <FormattedMessage id='labelOrderType' defaultMessage='Order Type' />
      </Typography>
      <Typography color={COLORS.DarkGray}>{orderType}</Typography>

      <Typography isBold color={COLORS.Primary} className='pt-4 pb-2'>
        <FormattedMessage id='labelAddress' defaultMessage='Address' />
      </Typography>
      <Typography color={COLORS.DarkGray}>{address}</Typography>
      <Typography color={COLORS.DarkGray}></Typography>
      <Typography isBold color={COLORS.Primary} className='pt-4 pb-2'>
        <FormattedMessage id='labelReferenceNo' defaultMessage='Reference No.' />
      </Typography>
      <Typography color={COLORS.DarkGray}>{referenceNo ? referenceNo : '-'}</Typography>
      <Typography isBold color={COLORS.Primary} className='pt-4 pb-2'>
        <FormattedMessage id='labelRemark' defaultMessage='Remark' />
      </Typography>
      <Typography color={COLORS.DarkGray}>{remark ? remark : '-'}</Typography>
      <Typography isBold color={COLORS.Primary} className='pt-4 pb-2'>
        <FormattedMessage id='labelTotalShippingPrice' defaultMessage='Customer’s Shipping Price' />
      </Typography>
      <Typography color={COLORS.DarkGray}>{customerShippingPrice ? customerShippingPrice : 0}</Typography>

      <Typography isBold color={COLORS.Primary} className='pt-4 pb-2'>
        <FormattedMessage id='labelCreatedDate' defaultMessage='Created Date' />
      </Typography>
      <Typography color={COLORS.DarkGray}>{createdDate}</Typography>

      <Typography isBold color={COLORS.Primary} className='pt-4 pb-2'>
        <FormattedMessage id='labelPlanShippingDate' defaultMessage='Plan Shipping Date' />
      </Typography>
      <Typography color={COLORS.DarkGray}>{planShippingDate}</Typography>

      {/* <Typography isBold color={COLORS.Primary} className='pt-4 pb-2'>
        <FormattedMessage id='labelEstimateTimeofarrival' defaultMessage='Estimate time of arrival (ETA)' />
      </Typography>
      <Typography color={COLORS.DarkGray}>{planShippingDate} - {etaDate}</Typography> */}

      <Typography isBold color={COLORS.Primary} className='pt-4 pb-2'>
        <FormattedMessage id='labelActualShippingDate' defaultMessage='Actual Shipping Date' />
      </Typography>
      <Typography color={COLORS.DarkGray}>{actualShippingDate ? actualShippingDate : '-'}</Typography>
      

      <Divider />

      <Row>
        <Col span={isDesktop ? 20 : 18}>
          <Typography isBold color={COLORS.Primary} className='pb-3'>
            <FormattedMessage id='labelPhoto' defaultMessage='Photo' />
          </Typography>
        </Col>
        <Col span={isDesktop ? 4 : 6}>
          <div onClick={onCollapsPhoto}>{_.get(trackingDetail, 'taskPhotoCount') || 0} <FormattedMessage id='labelPhotos' defaultMessage='Photos' /> {collaps ? <UpOutlined /> : <DownOutlined />}</div>
        </Col>
      </Row>

      {collaps ?
        <Upload
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
          listType="picture-card"
          fileList={fileList}
          showUploadList={{ showRemoveIcon: false }}
          onPreview={(file) => handlePreview(file)}
        /> : null}

      <Image
        wrapperStyle={{
          display: 'none',
        }}
        preview={{
          visible: previewOpen,
          onVisibleChange: (visible) => setPreviewOpen(visible),
          afterOpenChange: (visible) => !visible && setPreviewImage(''),
        }}
        src={previewImage}
      />

      {/* <ReactBnbGallery // lib rapidword
        show={visibleImgGallery}
        photos={modalViewGallery}
        onClose={() => setVisibleImgGallery(false)}
        activePhotoIndex={startIndexGallery}
      /> */}

    {/* <ImageGallery items={modalViewGallery} showNav={visibleImgGallery} showFullscreenButton={true}/> */}

      <Typography isBold color={COLORS.Primary} className='pt-5 pb-3'>
        <FormattedMessage id='labelParcel' defaultMessage='Parcel' /> ({totalParcel})
      </Typography>
      <Divider className='m-0 mb-4' />


      {_.map(parcels, (parcelNo, index) => {
        return (
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setFocusedTracking(parcelNo);
              setIsOpenTrackingModal(true);
            }}
          >
            {index !== 0 && <Divider className='m-0 my-3' />}
            <Row>
              <Col span={18}>
                <Typography isBold color={COLORS.DarkGray}>
                  {_.get(parcelNo, 'pacelNo')} 
                  {/* {_.get(parcelNo,'status.statusCode') === 'waiting' ? '' : `( ${_.get(parcelNo, 'statusText')} )`} */}
                </Typography>
              </Col>
              <Col span={6} className={`d-flex ${isDesktop ? "justify-content-end" : "justify-content-start mb-2"}`}>
                <div
                  style={{
                    backgroundColor: _.get(parcelNo,'status.statusColor'),
                    width: "135px",
                    height: "24px",
                    textAlign: "center",
                    borderRadius: "12px",
                    justifyContent: "center",
                    textAlignLast: "center",
                    marginRight: "10px"
                  }}
                >
                  <Typography color={COLORS.White} className="p-1">
                    {/* {_.get(parcelNo,'status.statusCode') === 'waiting' ? '' : `${_.get(parcelNo, 'statusText')}`} */}
                    {_.get(parcelNo, 'statusText')}
                  </Typography>
                </div>
              
              </Col>

            </Row>
           
          </div>
        );
      })}
      <Divider className='m-0 mt-4' />

      <TrackingModal isOpen={isOpenTrackingModal} onCancle={handleClickCancelTracking} data={focusedTracking} trackingDetail={trackingDetail} />
      <OrderModal
        isOpen={isOpenOrderModal}
        onCancle={handleCloseOrderModal}
        isEdit={isEdit}
        info={info}
        saveEditOrder={saveEditOrder}
        fromTracking={fromTracking}
        setIsOpenOrderModal={setIsOpenOrderModal}
      />

      {fromTracking === true && (
        <ShipmentPreviewModal
          info={info}
          isOpen={isOpenPreviewModal}
          onCancle={handleClosePreviewModal}
          parcels={parcels || []}
          totalParcel={totalParcel || 0}
        />
      )}
      <Modal
        className='custom-modal'
        open={isOpenConfirmModal}
        onCancel={() => {
          setIsOpenConfirmModal(false);
          setIsCancel(false);
        }}
        width={300}
        onOk={handleClickCancelShipment}
        centered={true}
        style={{ height: 'auto' }}
        footer={[
          <div>
            <MyButton
              onClick={() => {
                setIsOpenConfirmModal(false);
                setIsCancel(false);
              }}
              style={{
                width: isDesktop ? '30%' : '30%',
                marginLeft: '0px',
                marginTop: '0px',
                marginRight: '5px',
              }}
            >
              <FormattedMessage id='btnCancel' defaultMessage='Cancel' />
            </MyButton>{' '}
            <MyButton
              isPrimary
              onClick={handleClickCancelShipment}
              style={{
                width: isDesktop ? '30%' : '30%',
                marginInlineStart: '0px',
              }}
            >
              <FormattedMessage id='btnOK' defaultMessage='Ok' />
            </MyButton>
          </div>,
        ]}
      >
        <Typography isBold size='16px' color={COLORS.Primary} className='text-center p-2'>
          <FormattedMessage id='cancelShipment' defaultMessage='Cancel Shipment' />
        </Typography>
        <Typography className='text-center p-3 pb-4'>
          <FormattedMessage id='cancelShipmentText' defaultMessage='Do you want to cancel shipment ?' />
        </Typography>
      </Modal>


    </Modal>
  );
};

export default ShipmentDetailModal;
